import { render, staticRenderFns } from "./NormalSearchNav120.vue?vue&type=template&id=5d48df06&scoped=true"
import script from "./NormalSearchNav120.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav120.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d48df06",
  null
  
)

export default component.exports